export const DISCOUNT_CODE = 'ACCORD' as const;
